__turbopack_context__.v({
  "closeBtn": "PromoPopup-module-scss-module__1wOOEq__closeBtn",
  "fadeIn": "PromoPopup-module-scss-module__1wOOEq__fadeIn",
  "imgWrapper": "PromoPopup-module-scss-module__1wOOEq__imgWrapper",
  "popupBox": "PromoPopup-module-scss-module__1wOOEq__popupBox",
  "popupOverlay": "PromoPopup-module-scss-module__1wOOEq__popupOverlay",
  "summer_special_offer": "PromoPopup-module-scss-module__1wOOEq__summer_special_offer",
  "summer_special_offer_img": "PromoPopup-module-scss-module__1wOOEq__summer_special_offer_img",
  "summer_special_offer_img_mobile": "PromoPopup-module-scss-module__1wOOEq__summer_special_offer_img_mobile",
});
